
    export default 
    {
    "h5_redirect": {
        "bind_tip": "¿Estás seguro de que quieres vincularte a la cuenta Dsers usando la dirección de correo electrónico { email }?"
    }
}